import { Box } from "@mui/material";
import { useLocation } from "react-router-dom";
import BlogDetailsTwo from "../../components/Blog/BlogDetailsTwo";
import BlogDetailsThree from "../../components/Blog/BlogDetailsThree";
import BlogDetailsFour from "../../components/Blog/BlogDetailsFour";
import BlogDetailsFive from "../../components/Blog/BlogDetailsFive";

const BlogDetails = () => {
  const location = useLocation();

  // Option 1: Fetch blog details by blogId from an API or context
  // Option 2: Use static list from parent if passed via state or context

  return (
    <Box style={{ marginTop: 100, width: "100%" }}>
      <Box style={{ width: "100%" }}>
        {location?.pathname === "/blogdetails/0" && <BlogDetailsTwo />}
        {location?.pathname === "/blogdetails/1" && <BlogDetailsThree />}
        {location?.pathname === "/blogdetails/2" && <BlogDetailsFour />}
        {location?.pathname === "/blogdetails/3" && <BlogDetailsFive />}
      </Box>
    </Box>
  );
};

export default BlogDetails;
